import paper from 'paper'

import { convertAbsoluteDistanceToFeetAndInches } from '../../../components/markup/utils/helpers'
import { DRAWABLE_TYPES } from '../../../shared/constants/drawable-types'
import IndexableObject from '../../../shared/constants/general-enums/indexableObject'
import { isHeaderAndBeamGroup } from '../../../shared/services/drawable-groups-service'
import LabelTool from '../../lib/toolBoxes/2D/tools/label/Label.tool'

export function updateLabelPositionAndText(
    labelTool: LabelTool,
    item: paper.Item,
    type: DRAWABLE_TYPES,
    settings: IndexableObject,
    quantity: number
) {
    // update label position and content
    if (isHeaderAndBeamGroup(type, settings)) {
        const itemParent = item.parent

        if (item.children.length === 3 || itemParent.children.length === 3) {
            labelTool.updateLabelPosition(
                item.children.length === 3 ? (item as paper.Group) : (itemParent as paper.Group)
            )
        }

        const pointText = item.children.filter((child) => child instanceof paper.PointText)

        if (pointText.length === 1) {
            const { feet, inches } = convertAbsoluteDistanceToFeetAndInches(quantity)

            labelTool.updateLabelText(pointText[0] as paper.PointText, `${feet}' ${inches}''`)
        } else {
            console.warn('Item contain more then 1 point text or linear total is undefined')
        }
    }
}
